<template>
    <div class="contentBox liveListPage">
        <div class="pageTitle">
            <h1>直播频道</h1>
        </div>
        <div class="pageTitle">
            <div class="filterBox">
                <span>共{{channelCount}}个直播</span>
            </div>
            <div class="searchBox">
                <!--<input type="text" class="search" @focus="focusInput" @blur="inputBlur" v-model="searchVal"/>
                <div :class="[searchFocus ? 'focus' : '', 'searchBtn searchIcon']"></div>-->
                <button class="buyBtn" @click="jumpPage('/live/add')">
                    <img src="../../assets/plusIcon.svg" alt/>创建直播
                </button>
            </div>
        </div>
        <div class="liveListBoxWrap" v-if="channels.length">
            <div class="liveListBox">
                <template
                        v-for="(item, index) in channels">
                    <div class="listItem" :key="index">
                        <vue-loaders name="line-scale" class="playing" color="#67C23A" v-if="item.liveStatus === 'LIVING'"></vue-loaders>
                        <div class="listImgIcon">
                            <img :src="item.poster" alt=""/>
                        </div>
                        <a href="javascript:;" class="courseName">{{ item.title }}
                            <el-tag type="warning" size="small" v-if="(item.status & 2) !== 0 "><i class="el-icon-lock"></i>锁定</el-tag>
                            <el-tag type="warning" size="small" v-if="(item.status & (1 << 5)) !== 0 "><i class="el-icon-lock"></i>超管锁定</el-tag>
                            <el-tag type="danger" size="small" v-if="(item.status & (1 << 10)) !== 0"><i class="el-icon-turn-off-microphone"></i>禁播</el-tag></a>

                        <div class="timeWrap">
                            <div class="time">
                                <span>时间：</span>
                                <span>{{ item.time }}</span>
                            </div>
                        </div>
                        <div class="operateBox">
                            <div class="operateItem" @click="stream(item.channelId)">
                                <div class="imgIcon">
                                    <img src="../../assets/liveIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/liveIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">发起直播</a>
                            </div>
                            <div class="operateItem shareOperate" @click="share(item.channelId)">
                                <div class="imgIcon">
                                    <img src="../../assets/shareIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/shareIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">分享</a>
                            </div>
                            <div class="operateItem" @click="statistics(item.channelId)">
                                <div class="imgIcon">
                                    <img src="../../assets/dataIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/dataIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">监控统计</a>
                            </div>
                            <div class="moreBox">
                                <div class="moreOperate">
                                    <div class="moreOperateMain">
                                        <div class="moreItem editItem" @click="editChannel(item.channelId)">
                                            <span class="icon"></span>编辑
                                        </div>
                                        <div class="moreItem demandItem" @click="records(item.channelId)">
                                            <span class="icon"></span>录播
                                        </div>
                                        <el-popconfirm title="确定要锁定频道吗？" @confirm="lockChannel(item)" v-if="(item.status & 2) === 0">
                                            <div class="moreItem lockItem" slot="reference">
                                                    <span class="icon" ></span>锁定
                                            </div>
                                        </el-popconfirm>
                                        <div class="moreItem lockItem" @click="unlockChannel(item)" v-if="(item.status & 2) !== 0">
                                            <span class="icon" ></span>解锁
                                        </div>
                                        <el-popconfirm title="确定要删除频道吗？" @confirm="removeChannel(item)">
                                            <div class="moreItem deleteItem" slot="reference">
                                                    <span class="icon"></span>删除
                                            </div>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <div class="listPrompt">
            <!-- 无列表显示 -->
            <div class="noListMessIcon NoInformation" v-if="channels.length == 0">暂无信息</div>
        </div>
        <div class="paginationBox" v-if="channels.length > pageSize">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize"
                           layout="prev, pager, next" :total="currentTotal" prev-text="上一页"
                           next-text="下一页"></el-pagination>
        </div>
    </div>
</template>

<script>
    import common from '../../common.vue';
    import moment from 'moment';
    import 'vue-loaders/dist/vue-loaders.css';

    // 已弃用
    const STATUS_NAME_MAPPER = {
        "0": "下线",
        "1": "正常",
        "9": "锁定",
        "13": "禁播"
    };
    const LOCK_ERROR_MAPPER = {
        "0": "成功",
        "-1": "登录已过期",
        "2": "访问被拒绝"
    };

    export default {
        name: "LiveList",
        data() {
            return {
                searchVal: '',
                searchFocus: false,
                currentPage: 1,
                pageSize: 12,
                currentTotal: 0,
                liveSort: "",
                channelCount: 0,
                channels: []
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            editChannel(cid){
                this.$router.push({
                    path: '/live/edit',
                    name: 'LiveEdit',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            stream(cid){
                this.$router.push({
                    path: '/live/launch',
                    name: 'LiveLaunch',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            share(cid){
                this.$router.push({
                    path: '/live/share',
                    name: 'ChannelShare',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            statistics(cid){
                this.$router.push({
                    path: '/live/statistics',
                    name: 'Statistics',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            records(cid){
                this.$router.push({
                    path: '/live/history',
                    name: 'LiveHistory',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            focusInput() {
                this.searchFocus = true;
            },
            inputBlur() {
                this.searchFocus = false;
            },

            setCurrentTotal() {
                this.currentTotal = this.channels.length;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                console.log(`当前页: ${val}`);
            },
            getChannels() {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/channelList').then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data){
                        _this.channelCount = r.count;
                        _this.formatChannels(r.data);
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 格式化频道数据
             * @param channels
             */
            formatChannels(channels){
                if(!channels){ return; }

                (channels || []).forEach(function(item){
                    item.statusTitle = STATUS_NAME_MAPPER[item.status + ""];
                    item.time = moment(item.lastActive || item.createTime).format("YYYY-MM-DD HH:mm");
                });
                this.channels = channels;
            },
            // 删除频道
            removeChannel(channel){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/channel/remove', this.$qs.stringify({channelId: channel.channelId})).then(function (res) {
                    let r = res.data;

                    if (r.code === -1){
                        _this.$message({
                            message: "登录已过期，请重新登录",
                            type: 'warning',
                            duration: 1000,
                            onClose: () => {
                                window.location.href = common.LOGON_URL;
                            }
                        });
                    }else if(r.code === 0){
                        // 频道设置为删除状态，从列表中删除
                        let index = _this.getChannelIndex(channel.channelId);
                        index >= 0 && _this.channels.splice(index, 1);
                    }
                });
            },
            // 获取频道在列表中的索引
            getChannelIndex(channelId){
                let index = -1;
                for(let i=0; i<this.channels.length; i++){
                    if(this.channels[i].channelId === channelId){
                        index = i;
                    }
                }
                return index;
            },
            // 锁定频道
            lockChannel(channel){
                this.setChannelStatus(channel, true);
            },
            // 解锁频道
            unlockChannel(channel){
                this.setChannelStatus(channel, false);
            },
            // 设置频道状态
            setChannelStatus(channel, lock){
                let _this = this, uri = common._BASE_ + (lock? 'channel/lockChannel': 'channel/unlockChannel');
                _this.$axios.post(uri,
                    this.$qs.stringify({channelId: channel.channelId})).then(function (res) {
                    let r = res.data;
                    if(r.code === 0){
                        let ch = _this.channels.find(c => c.channelId === channel.channelId);
                        if(ch){
                            let s = ch.status;
                            ch.status = lock? (s | 2) : (s & (~2));
                        }
                    }else{
                        _this.$notify({
                            title: '错误',
                            message: LOCK_ERROR_MAPPER[r.code + ''],
                            type: 'error',
                            duration: 1000,
                            onClose: function(){
                                if(r.code < 0){ _this.$router.push('/login');}
                            }
                        });

                    }
                });
            }
        },
        mounted() {
            //this.setCurrentTotal();
            this.getChannels();
        },
    };
</script>

<style lang="less">
    .liveListPage {
        .pageTitle {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            h1 {
                height: 20px;
                line-height: 24px;
                font-size: 20px;
                font-weight: bold;
                color: #221816;
            }

            .filterBox {
                .el-select .el-input__inner::-webkit-input-placeholder {
                    color: #33363f;
                }

                .el-select .el-input__inner::-moz-input-placeholder {
                    color: #33363f;
                }

                .el-select .el-input__inner::-ms-input-placeholder {
                    color: #33363f;
                }
            }

            .searchBox {
                position: relative;
                display: flex;

                .search {
                    width: 437px;
                    height: 40px;
                    border: solid 1px #e8e8e8;
                    background: #fff;
                    border-radius: 6px;
                    padding-left: 12px;
                }

                .search:focus {
                    border: 1px solid #306ff6;
                }
            }

            .buyBtn {
                width: 137px;
                height: 40px;
                background: #076eff;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-weight: 400;
                color: #ffffff;
                margin-left: 10px;

                img {
                    margin-right: 6px;
                }
            }

            .buyBtn:hover {
                background: #4aa3f8;
            }

            .filterSelect {
                width: 140px;
                margin-right: 10px;
            }

            span {
                color: #a2a9ab;
            }
        }

        // .liveListBoxWrap {
        //     height: 850px;
        // }

        .liveListBox {
            display: flex;
            flex-wrap: wrap;

            .listItem {
                margin-right: 30px;
                margin-bottom: 20px;
            }

            .listItem .playing {
                position: absolute;
                width: 48px;
                top: 50px;
                left: 50%;
                right: 0;
                margin-left: -24px;
                z-index: 2;
            }

            .listItem:nth-child(4n + 4) {
                margin-right: 0;
            }

            .courseName {
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-bottom: 0;

                .el-tag{
                    float: right
                }
            }

            .timeWrap {
                border-top: none;
            }

            .operateBox {
                height: 38px;
                display: flex;
                align-items: center;
                border-top: 1px solid #e8e8e8;
                padding-left: 10px;
                position: relative;

                .operateItem {
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    .imgIcon {
                        width: 12px;
                        height: 12px;
                        margin-right: 4px;
                        position: relative;

                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        img.hover {
                            display: none;
                        }
                    }
                }

                .operateItem:hover {
                    .imgIcon {
                        img.normal {
                            display: none;
                        }

                        img.hover {
                            display: block;
                        }
                    }
                }

                .shareOperate {
                    margin: 0 18px;
                }

                .moreBox {
                    width: 33px;
                    height: 38px;
                    border-left: 1px solid #e8e8e8;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: url("../../assets/moreIcon.svg") no-repeat center center;
                    cursor: pointer;
                }

                .moreBox:hover {
                    background: #306ff6 url("../../assets/moreIcon-white.svg") no-repeat center center;

                    .moreOperate {
                        display: block;
                    }
                }

                .moreOperate {
                    width: 106px;
                    height: 160px;
                    position: absolute;
                    top: 0;
                    right: -106px;
                    display: none;
                    z-index: 99;

                    .moreOperateMain {
                        width: 100px;
                        height: 160px;
                        margin-left: 6px;
                        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
                        font-size: 12px;
                        line-height: 40px;
                    }

                    .moreItem {
                        width: 100px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        color: #55565f;
                        background: #fff;
                        cursor: pointer;

                        span.icon {
                            width: 14px;
                            height: 12px;
                            display: inline-block;
                            margin-right: 8px;
                            margin-left: 19px;
                        }
                    }

                    .moreItem:hover {
                        color: #221816;
                        background: #f5f6f7;
                    }

                    .moreItem.editItem span.icon {
                        background: url("../../assets/edit-gray.svg") center center no-repeat;
                    }

                    .moreItem.demandItem span.icon {
                        background: url("../../assets/demand-gray.svg") center center no-repeat;
                    }

                    .moreItem.lockItem span.icon {
                        background: url("../../assets/lock-gray.svg") center center no-repeat;
                    }

                    .moreItem.deleteItem span.icon {
                        background: url("../../assets/delete-gray.svg") center center no-repeat;
                    }

                    .moreItem.editItem:hover span.icon {
                        background: url("../../assets/edit-black.svg") center center no-repeat;
                    }

                    .moreItem.demandItem:hover span.icon {
                        background: url("../../assets/demand-black.svg") center center no-repeat;
                    }

                    .moreItem.lockItem:hover span.icon {
                        background: url("../../assets/lock-black.svg") center center no-repeat;
                    }

                    .moreItem.deleteItem:hover span.icon {
                        background: url("../../assets/delete-black.svg") center center no-repeat;
                    }
                }
            }
        }
    }
</style>